<template>
    <div>
        <le-search-form @reset="handlerRest" @search="handlerSearch" :canPackUp="true" id="leSearch">
            <le-select-local-search label="退款来源" v-model="pageParam.params.refundType" :options="refundTypeDic" />
            <le-date-range 
                label="退款时间" 
                :minDate.sync="pageParam.params.startTime" 
                :maxDate.sync="pageParam.params.endTime" 
                valueFormat="yyyy-MM-dd HH:mm:ss" 
                :defaultTime="['00:00:00','23:59:59']" />
        </le-search-form>
        <le-pagview ref="cardRefundPage" @setData="setTableData" :pageParam="pageParam" :pagerCount="5" :isFixed="true" :tableRef="$refs.cardRefundList">
            <el-table ref="cardRefundList" :data="tableData" :highlight-current-row="true" v-sticky="{ top: 0, parent:'.el-card__body' }" style="width: 100%">
                <el-table-column prop="" label="退款金额" min-width="120">
                    <template slot-scope="{ row }">
                        <span>￥{{ util.numFormat(row.refundAmount) }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="" label="退款来源" min-width="120">
                    <template slot-scope="{ row }">
                        <span>{{ row.refundType | initDic(refundTypeDic) }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="退款方式" prop="content">
                    <template slot-scope="{ row }">
                        <span>{{ row.refundWay | initDic(refundWayDic) }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="amount" label="退款原因" min-width="120">
                    <template slot-scope="{ row }">
                        <span>{{ row.refundMsg || '-' }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="myOrderNum" label="退款状态" min-width="120">
                    <template slot-scope="{ row }">
                        <span>{{ util.initDic(row.refundStatus, 'refundStatus') }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="myOrderNum" label="退款时间" min-width="120">
                    <template slot-scope="{ row }">
                        <span>{{ row.refundTime || '-' }}</span>
                    </template>
                </el-table-column>
                <!-- <el-table-column prop="name" label="操作" width="75" fixed="right">
                    <template slot-scope="scope">
                        <el-tooltip class="item" effect="dark" content="编辑" placement="top">
                            <img src="../../assets/icon/option-edit.png" class="a-wh-16" @click="handleEdit(scope.row)" />
                        </el-tooltip>
                    </template>
                </el-table-column> -->
            </el-table>
        </le-pagview>
    </div>
</template>

<script>
    import util from "@/utils/util.js";
    export default {
        data () {
            return {
                tableData: [],
                util: util,
                pageParam: {
                    url: this.$Config.apiUrl.userOrCardRefundPage,
                    method: "post",
                    params: {
                        "balanceId": this.id,
                        "endTime": "",
                        "payType": "44",
                        "refundType": "",
                        "startTime": "",
                        "userId": this.userId
                    },
                    freshCtrl: 1,
                },
                refundTypeDic: [],
                refundWayDic: [
                    {
                        label: '线上',
                        value: '0'
                    },
                    {
                        label: '线下',
                        value: '1'
                    },
                ]
            }
        },
        props: ['id', 'userId', 'cardBalance'],
        created () {
            this.$getDic('cardRechargeRefundType','select').then(res=>{ this.refundTypeDic = res; })
        },
        methods: {
            setTableData(data) {
                this.tableData = data;
            },
            handlerRest() {
                this.pageParam.params = {
                    "balanceId": this.id,
                    "endTime": "",
                    "payType": "44",
                    "refundType": "",
                    "startTime": "",
                    "userId": this.userId
                };
                this.handlerSearch()
            },
            handlerSearch() {
                this.$refs['cardRefundPage'].pageNum = 1
                this.pageParam.freshCtrl++;
            },
        }
    }
</script>

<style lang="scss" scoped>
    /deep/ .el-table__body-wrapper::-webkit-scrollbar {
		/*width: 0;宽度为0隐藏*/
		width: 0 !important;
		height: 0 !important;
	}
	/deep/ .el-table__fixed, /deep/ .el-table__fixed-right{
		height: 100% !important;
	}
    /deep/ .companySelect{
        .a-ml-20{
            margin-left: 10px !important;
        }
    }
</style>